import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  '@global': {
    '.mobile-sticky-bottom': {
      [theme.breakpoints.down('md')]: {
        bottom: theme.spacing(-10),
        transition: 'bottom 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important',
      },
    },
    '.sticky': {
      position: 'fixed',
      top: '0',
      '&.mobile-sticky-bottom': {
        top: 'inherit',
        [theme.breakpoints.down('md')]: {
          bottom: '0',
          transform: 'none',
        },
        [theme.breakpoints.up('lg')]: {
          top: '0',
          bottom: 'inherit',
        },
      },
      '&.header-added': {
        transform: `translateY(${theme.spacing(10)})`,
        transition: 'transform 250ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
        [theme.breakpoints.up('lg')]: {
          transform: `translateY(${theme.spacing(16)})`,
        },
      },
      '&.header-removed': {
        transform: `translateY(${theme.spacing(0)})`,
        transition: 'transform 50ms cubic-bezier(0.4, 0, 0.6, 1) 0ms',
      },
    },
  },
}));
